import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import client, { endpoints } from '../api/client';

const SORTS = [['newest', 'Newest'], ['votes', 'Votes'], ['unanswered', 'Unanswered'], ['views', 'Views']];
const LIMIT = 15;

export default function Questions() {
  const [data, setData] = useState({ questions: [], total: 0 });
  const [sort, setSort] = useState('newest');
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await client.get(endpoints.questions.list, { params: { sort, search, skip: page * LIMIT, limit: LIMIT } });
      setData(data);
    } finally { setLoading(false); }
  }, [sort, search, page]);
  useEffect(() => { load(); }, [load]);

  const totalPages = Math.max(1, Math.ceil((data.total || 0) / LIMIT));
  return (
    <div className="container community">
      <div className="page-head">
        <div><h1>Questions &amp; Answers</h1><p className="muted">Ask, answer and upvote.</p></div>
        <Link to="/questions/ask" className="btn-primary">Ask a question</Link>
      </div>
      <div className="toolbar">
        <div className="seg">{SORTS.map(([k, l]) => <button key={k} className={sort === k ? 'on' : ''} onClick={() => { setSort(k); setPage(0); }}>{l}</button>)}</div>
        <form onSubmit={(e) => { e.preventDefault(); setPage(0); load(); }} className="search">
          <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search questions…" />
          <button className="btn-ghost">Search</button>
        </form>
      </div>
      {loading ? <p className="muted">Loading…</p> : data.questions.length === 0 ? (
        <p className="muted">No questions yet. <Link to="/questions/ask">Ask the first one →</Link></p>
      ) : (
        <div className="qlist">
          {data.questions.map((q) => (
            <article key={q.slug} className="qcard">
              <div className="qstats">
                <div><strong>{q.score}</strong><span>votes</span></div>
                <div className={q.hasAccepted ? 'accepted' : ''}><strong>{q.answerCount}</strong><span>answers</span></div>
                <div><strong>{q.views}</strong><span>views</span></div>
              </div>
              <div className="qbody">
                <h3><Link to={`/questions/${q.slug}`}>{q.title}</Link></h3>
                <p className="muted">{q.excerpt}</p>
                <div className="qfoot">
                  <div className="tags">{(q.tags || []).map((t) => <span key={t} className="tag">{t}</span>)}</div>
                  {q.author && <span className="byline">{q.author.name}</span>}
                </div>
              </div>
            </article>
          ))}
        </div>
      )}
      {totalPages > 1 && (
        <div className="pager">
          <button className="btn-ghost" disabled={page === 0} onClick={() => setPage(page - 1)}>← Prev</button>
          <span className="muted">Page {page + 1} of {totalPages}</span>
          <button className="btn-ghost" disabled={page + 1 >= totalPages} onClick={() => setPage(page + 1)}>Next →</button>
        </div>
      )}
    </div>
  );
}
